"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Google = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Google = function Google() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M24 11.72C24 17.253 21.052 24 12.172 24 5.499 24.044.051 18.674 0 12 .051 5.326 5.5-.044 12.173 0c2.76.01 5.438.95 7.6 2.667.15.122.24.3.253.493a.733.733 0 01-.213.52 35.211 35.211 0 00-2.48 2.507.653.653 0 01-.88.08 6.813 6.813 0 00-4.267-1.334 7.133 7.133 0 000 14.267c4 0 5.694-1.707 6.573-4.733h-6.093A.667.667 0 0112 13.8v-3.533c0-.369.298-.667.666-.667h10.667a.6.6 0 01.6.533c.05.528.071 1.057.066 1.587z"
  });
};

exports.Google = Google;